<script setup>
  import {useDeveloperMode} from "@/resources/js/Composable/useDeveloperMode.js";

  const isDeveloper = useDeveloperMode();
</script>

<template>
  <template v-if="isDeveloper">
    <slot />
  </template>
</template>
